module.exports = __webpack_public_path__ + "static/academic-149d2ab4013ece05ae99028558c8e114.png";